/* eslint-disable vars-on-top */
/* eslint-disable no-undef */
/* eslint-disable no-console */

/**
 * Adds transparent header styles on homepage when banner is visible
 */
export default function initTransparentHeader() {
  const isHomePage = document.querySelector('.page[data-action="Home-Show"]');
  const header = document.querySelector('.transparent-header-home');
  const menus = document.querySelectorAll('.transparent-menu');
  const mobileMenu = document.querySelector('.primary-category-slider');
  const banner = document.querySelector('.header-banner');
  const searchInput = document.querySelector('.site-search input.form-control');
  const rightSearchInput = document.querySelector('.header-item__search.right .site-search input.form-control');

  let isBannerVisible = false;
  let isHeaderHovered = false;
  let isSearchActive = false;

  function setInitialState() {
    try {
      if (header) {
        header.classList.remove('t-header');
      }
      menus.forEach((menu) => {
        menu.classList.remove('t-menu');
      });
      if (mobileMenu) {
        mobileMenu.classList.remove('t-menu');
      }
    } catch (err) {
      console.error('Error while applying initial state', err);
    }
  }

  setInitialState();

  // If not homepage or missing required elements, just exit after setting initial state
  if (!isHomePage || !header || menus.length === 0 || !banner) {
    return;
  }

  function updateStyles() {
    try {
      const isDrawerOpen = document.querySelector('.nav-menu--visible') !== null;
      if (isHomePage && (isHeaderHovered || !isBannerVisible || isSearchActive || isDrawerOpen)) {
        // Apply normal styles (when hovered OR banner not visible)
        header.classList.remove('t-header');
        mobileMenu.classList.remove('t-menu');
        menus.forEach((menu) => {
          menu.classList.remove('t-menu');
        });
      } else {
        // Apply transparent styles (when banner visible AND not hovered)
        header.classList.add('t-header');
        mobileMenu.classList.add('t-menu');
        menus.forEach((menu) => {
          menu.classList.add('t-menu');
        });
      }
    } catch (err) {
      setInitialState();
      console.error('transparentHeader updateStyles error', err);
    }
  }

  // Add hover event listeners
  header.addEventListener('mouseenter', () => {
    isHeaderHovered = true;
    updateStyles();
  });

  header.addEventListener('mouseleave', () => {
    isHeaderHovered = false;
    updateStyles();
  });

  if (searchInput) {
    searchInput.addEventListener('focus', () => {
      isSearchActive = true;
      updateStyles();
    });

    searchInput.addEventListener('blur', () => {
      isSearchActive = false;
      updateStyles();
    });
  }

  if (rightSearchInput) {
    rightSearchInput.addEventListener('focus', () => {
      isSearchActive = true;
      updateStyles();
    });

    rightSearchInput.addEventListener('blur', () => {
      isSearchActive = false;
      updateStyles();
    });
  }
  // Intersection Observer to monitor banner visibility
  const observer = new IntersectionObserver(((entries) => {
    entries.forEach((entry) => {
      if (entry.target === banner) {
        isBannerVisible = entry.isIntersecting;
        updateStyles();
      }
    });
  }), {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });
  observer.observe(banner);

  // Debounce function to limit how often a function can fire
  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  // Update CSS variable for header height
  function updateHeaderHeight() {
    try {
      const pageHeader = document.querySelector('header');
      if (!pageHeader || !document.documentElement) return;
      const h = Math.floor(pageHeader.getBoundingClientRect().height || 0);
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    } catch (e) {
      console.error('updateHeaderHeight error', e);
    }
  }
  updateHeaderHeight();
  window.addEventListener('resize', debounce(updateHeaderHeight, 100));

  window.addEventListener('beforeunload', () => {
    observer.disconnect();
    if (searchInput) {
      searchInput.removeEventListener('focus', () => {});
      searchInput.removeEventListener('blur', () => {});
    }
    if (rightSearchInput) {
      rightSearchInput.removeEventListener('focus', () => {});
      rightSearchInput.removeEventListener('blur', () => {});
    }
  });
}
